import { getCameraInstallationAnalytics } from '@api/services/analytics.service';
import { getAllGridWallRequests, getGridWallRequest } from '@api/services/gridwall-request.service';
import useDataQuery from '@hooks/use-data-query';

interface IGridwallRequest {
    gridwallId: string;
}

const useGridwallRequestData = (props: IGridwallRequest) => {
    const { gridwallId } = props;
    const query = useDataQuery(['grid-wall-request', gridwallId], () => getGridWallRequest(gridwallId));

    return {
        gridwallRequest: query.data,
        isLoading: query.isLoading,
    };
};

export default useGridwallRequestData;
